import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import "./assets/css/elements-css/header.css";
import "./assets/css/elements-css/footer.css";
import "./assets/css/global.css";
import "./assets/css/style.css";
import "./assets/css/animate.css";
import "./assets/css/aos.css";
import "./assets/css/bootstrap.css";
import "./assets/css/fontawesome-all.css";
import "./assets/css/icomoon.css";
import "./assets/css/jquery-ui.css";
import "./assets/css/jquery.fancybox.min.css";
import "./assets/css/nice-select.css";
import "./assets/css/responsive.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
// ...baaki CSS imports

import Header from "../components/Header.jsx";
import Footer from "../components/Footer.jsx";
import Home from "../components/Home.jsx";
import About from "../components/About.jsx";
import ContactUs from "../components/ContactUs.jsx";
import AccountHandlingServices from "../components/AccountHandlingServices.jsx";
import PortfolioManagementServices from "../components/PortfolioManagementServices.jsx";
import NonRecourseLoan from "../components/NonRecourseLoan.jsx";
import TermsAndConditions from "../components/TermsAndConditions.jsx";
import ScrollToTop from "../components/ScrollToTop.jsx";
import ScrollToTopButton from "../components/ScrollToTopButton.jsx";
import AuthModal from "../components/AuthModal.jsx";
import UserProfile from "../components/UserProfile.jsx";
import FounderProfile from "../components/FounderProfile.jsx";
import Preloader from "../components/Preloader.jsx";
import PricingPage from "../components/Pricingpage.jsx";
import Marketplace from "../components/Marketplace.jsx";
import ExploreStrategy from "../components/ExploreStrategy.jsx";
import MyStrategies from "../components/MyStrategies.jsx";
import CreateStrategy from "../components/CreateStrategy.jsx";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // loader duration
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Preloader hide={!loading} />

      <div className={`site-content ${!loading ? "show" : ""}`}>
        <Header />
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route
            path="/account-handling-services"
            element={<AccountHandlingServices />}
          />
          <Route
            path="/portfolio-management-services"
            element={<PortfolioManagementServices />}
          />
          <Route path="/non-recourse-loan" element={<NonRecourseLoan />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/Marketplace" element={<Marketplace />} />
          <Route path="/MyStrategies" element={<MyStrategies />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route path="/profile" element={<UserProfile />} />
          <Route path="/founder-profile" element={<FounderProfile />} />
          <Route path="/ExploreStrategy" element={<ExploreStrategy />} />
          <Route path="/CreateStrategy" element={<CreateStrategy />} />
        </Routes>

        <Footer />
        <AuthModal />
        <ScrollToTopButton />
      </div>
    </>
  );
}

export default App;
